module.exports = __webpack_public_path__ + "static/img/m_ph02.9db75b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/drawn/m_ph02.jpg
// module id = RovK
// module chunks = 0